import { usePomodoro } from '#app/utils/pomodoro.js'

export default function Index() {
	const {
		start: start1,
		reset: reset1,
		pause: pause1,
		timeLeft: timeLeft,
		status: status1,
	} = usePomodoro(5000, {
		finish: () => console.log('Pomodoro 1 finished'),
		start: () => console.log('Pomodoro 1 started'),
		pause: () => console.log('Pomodoro 1 paused'),
		reset: () => console.log('Pomodoro 1 reset'),
	})
	const {
		start: start2,
		reset: reset2,
		pause: pause2,
		timeLeft: timeLeft2,
		status: status2,
	} = usePomodoro(20000, {
		finish() {
			console.log('Pomodoro 2 finished')
		},
	})

	function start() {
		start1()
		start2()
	}

	function reset() {
		reset1()
		reset2()
	}

	function pause() {
		pause1()
		pause2()
	}

	return (
		<div className="flex gap-2">
			<span className="font-extrabold">
				{timeLeft} {status1}
			</span>
			<span className="font-extrabold">
				{timeLeft2} {status2}
			</span>
			<button onClick={start}>Start</button>
			<button onClick={reset}>Reset</button>
			<button onClick={pause}>Pause</button>
		</div>
	)
}
